const onRun = () => {
    const subscribe = document.querySelector('#newsletter-form');
    if (subscribe !== null) {
        subscribe.addEventListener('submit', (e) => {
            e.preventDefault();
            const email = document.querySelector('#newsletter-email').value;
            const termsChecked = document.querySelector('#nl-terms').checked;
            const errorElement = document.querySelector('#nl-terms-error');

            if (!termsChecked) {
                errorElement.style.display = 'block';
                return;
            } else {
                errorElement.style.display = 'none';
                subscribe.querySelector('input[type="submit"]').disabled = true;

                fetch('/api/subscribe', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json',
                        'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
                    },
                    body: JSON.stringify({
                        email: email
                    })
                }).then(response => {
                    if (response.status === 201) {
                        document.querySelector('.newsletter__success').classList.remove('hidden');
                        subscribe.classList.add('hidden');
                    }
                });
            }
        });

        const subscribeTerms = document.querySelector('#nl-terms');

        if (subscribeTerms !== null) {
            subscribeTerms.addEventListener('change', function() {
                if(this.checked) {
                    document.querySelector('.text-red').style.display = 'none';
                }
            });
        }
    }
};
if(document.readyState !== 'loading') {
    onRun();
} else {
    document.addEventListener('DOMContentLoaded', function () {
        onRun()
    });
}
